import React = require("react");
import Select from "react-select";
import { ready } from "../../../../custom_api/api_utils";
import { SearchOn } from "../../../../custom_api/collection/types";
import { JumboKiosk } from "../../Kiosk/JumboKiosk";
import { Loader } from "../../loader";
import { customSelectStyles, customSelectTheme } from "../Shared/AsyncSelectStyles";
import { InspirationBaseSelector, inspirationLabelsKiosk } from "../Shared/InspirationBaseSelector";
import { contentTexts, jumboText } from "../Shared/InspirationUtils";
import BookSliderKiosk from "./BookSliderKiosk";
import { ThemeBasedInspirationLayoutProps } from "./ThemeBasedInspirationState";

export const ThemeBasedInspirationLayoutKiosk = (props: ThemeBasedInspirationLayoutProps) => {
  const { popularThemes, collectionPage, routePath, searchResults, searchQuery, pushDataLayer, updateSearchQuery, pickTheme } = props

  return (
    <div className="inspiration-page ip ip--kiosk ip--theme-based-inspiration" key="ThemeBasedInspirationLayout">
      <JumboKiosk {...jumboText.theme} size="large" />

      <div className={"ip__content"}>
        {popularThemes.kind != 'loaded' ? <Loader /> :
          <div className="layout">
            <div className="layout__content">
              <div className="layout__filter">
                <BookSliderKiosk
                  selectionPrompt={contentTexts.theme.selectionPrompt}
                  popularThemes={popularThemes.value}
                  pushDataLayer={pushDataLayer}
                  routePath={routePath}
                />
              </div>
              <div className="searchbar--kiosk">
                <div className="searchbar--kiosk__inner">
                  <h2 className="searchbar--kiosk__title">{contentTexts.theme.searchTitle}</h2>
                  <div className="searchbar--kiosk__input">
                  <Select<SearchOn>
                      className="searchbar__select react-select"
                      classNamePrefix="react-select"
                      placeholder={contentTexts.theme.searchPlaceholder}
                      styles={customSelectStyles}
                      theme={(theme) => customSelectTheme(theme)}
                      noOptionsMessage={() => 'Geen suggesties gevonden.'}
                      isClearable={true}
                      onInputChange={updateSearchQuery}
                      onChange={pickTheme}
                      inputValue={searchQuery}
                      options={ready(searchResults) ? searchResults.value : []}
                      onMenuOpen={ () => {} }
                      onMenuClose={ () => {} }
                      value={undefined}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <InspirationBaseSelector activeBase="theme" routePath={routePath} labels={inspirationLabelsKiosk} />
    </div>)
}

